// Presentation only: this metadata never feeds account permissions or CRM fields.
export function schoolTeamOverlay(record) {
  const value = record?.schoolTeamCoverage
  return value?.status !== 'not_applicable' && value && typeof value === 'object' && value.readOnly === true && value.grantsAccess === false ? value : null
}

export function linkedCoverageMembers(record) {
  const overlay = schoolTeamOverlay(record)
  return overlay?.status === 'linked' && Array.isArray(overlay.members) ? overlay.members.filter(m => m?.id && m?.name) : []
}

export function coverageMemberOptions(records = []) {
  return [...new Map(records.flatMap(linkedCoverageMembers).map(m => [String(m.id),m])).values()]
    .sort((a,b) => a.name.localeCompare(b.name) || String(a.id).localeCompare(String(b.id)))
}

export function matchesCoverageMember(record, id) {
  return !id || linkedCoverageMembers(record).some(m => String(m.id) === String(id))
}

export const COVERAGE_STATUS = {
  linked:'Linked bowl coverage',
  missing_link:'Bowl coverage: confirmed school link missing',
  conflict:'Bowl coverage: conflicting school links',
  review_required:'Bowl coverage: team needs review',
  unavailable:'Bowl coverage could not be read',
}

export function coverageExportText(record) {
  const value = schoolTeamOverlay(record)
  if (!value) return ''
  const groups = (Array.isArray(value.scopes) ? value.scopes : []).map(scope =>
    `${scope.school || 'School not identified'} (${scope.conference || 'conference not identified'}): ${(scope.members || []).map(m => `${m.name} [${m.role}]`).join(' + ')}`)
  return [COVERAGE_STATUS[value.status] || 'Bowl coverage status unavailable',value.season,value.sport,...groups].filter(Boolean).join(' | ')
}

// A named display filter can resolve to an exact active identity only when the
// backend-provided linked catalog has one unambiguous ID for that exact name.
export function coverageIdForRepName(records, name) {
  const ids = new Set(coverageMemberOptions(records).filter(member => member.name === name).map(member => String(member.id)))
  return ids.size === 1 ? [...ids][0] : null
}
